// blog-gwa.js — v2
// Pattern: 6 small cards → 1 wide → 6 small → 1 wide → …
// Batch size = 13 (6 + 1 + 6). Load more adds next 13.
// Wide card alternates image side: even wide = img right, odd = img left.

(() => {
  const BATCH      = 13; // 6 small + 1 wide + 6 small
  const WIDE_EVERY = 13; // position % 13 === 6 → wide card (6, 19, 32, …)

  document.addEventListener('DOMContentLoaded', () => {
    const grid       = document.querySelector('[data-bgwa-grid]');
    const pagination = document.querySelector('[data-bgwa-pagination]');
    const loadBtn    = document.querySelector('[data-bgwa-loadmore]');
    const tabs       = document.querySelectorAll('[data-bgwa-tab]');
    const allCards   = Array.from(document.querySelectorAll('[data-bgwa-card]'));

    if (!grid || !allCards.length) return;

    let activeTab  = '__all';
    let shownCount = 0;
    let wideCount  = 0;

    // ── Helpers ──────────────────────────────────────────────────────────────

    function getFiltered() {
      if (activeTab === '__all') return allCards;
      return allCards.filter(c => c.dataset.bgwaCategory === activeTab);
    }

    function isWidePosition(pos) {
      return pos % WIDE_EVERY === 6; // 6, 19, 32, …
    }

    function styleCard(card, pos, localWideCount) {
      const wide = isWidePosition(pos);
      card.classList.toggle('is-wide',  wide);
      card.classList.toggle('is-small', !wide);

      if (wide) {
        const imgRight = localWideCount % 2 === 0;
        card.classList.toggle('is-img-right', imgRight);
        card.classList.toggle('is-img-left',  !imgRight);
      } else {
        card.classList.remove('is-img-right', 'is-img-left');
      }
    }

    // ── Render batch ─────────────────────────────────────────────────────────

    function renderBatch(filtered, from, count) {
      let localWideCount = wideCount;
      const end = Math.min(from + count, filtered.length);

      for (let i = from; i < end; i++) {
        const card = filtered[i];
        styleCard(card, i, localWideCount);
        if (isWidePosition(i)) localWideCount++;
        card.style.display = '';
      }

      wideCount  = localWideCount;
      shownCount = end;
    }

    function showPagination(show) {
      if (!pagination) return;
      pagination.style.display = show ? 'flex' : 'none';
    }

    // ── Reset ─────────────────────────────────────────────────────────────────

    function reset() {
      allCards.forEach(c => {
        c.style.display = 'none';
        c.classList.remove('is-wide', 'is-small', 'is-img-right', 'is-img-left');
      });
      shownCount = 0;
      wideCount  = 0;
    }

    function initialRender() {
      reset();
      const filtered = getFiltered();
      renderBatch(filtered, 0, BATCH);
      showPagination(filtered.length > shownCount);
    }

    // ── Load more ─────────────────────────────────────────────────────────────

    if (loadBtn) {
      loadBtn.addEventListener('click', () => {
        const filtered  = getFiltered();
        const prevShown = shownCount;
        renderBatch(filtered, shownCount, BATCH);
        showPagination(filtered.length > shownCount);

        // Scroll to first new card
        if (filtered[prevShown]) {
          setTimeout(() => {
            filtered[prevShown].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 50);
        }
      });
    }

    // ── Tabs ──────────────────────────────────────────────────────────────────

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const val = tab.dataset.bgwaTab;
        if (val === activeTab) return;
        activeTab = val;

        tabs.forEach(t => {
          t.classList.toggle('is-active', t.dataset.bgwaTab === activeTab);
          t.setAttribute('aria-selected', t.dataset.bgwaTab === activeTab ? 'true' : 'false');
        });

        initialRender();
      });
    });

    // ── Init ──────────────────────────────────────────────────────────────────
    initialRender();
  });
})();